<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Address</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Address</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addAddressForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input class="form-control resize-none" id="name" type="text" rows="3" formControlName="name">
                                        <small *ngIf="submitted && addAddressForm.get('name').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contact">Contact No.</label>
                                        <input class="form-control resize-none" id="contact" type="text" rows="3" formControlName="contact">
                                        <small *ngIf="submitted && addAddressForm.get('contact').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="address">Address</label>
                                        <textarea class="form-control resize-none" id="address" type="text" rows="3" formControlName="address"></textarea>
                                        <small *ngIf="submitted && addAddressForm.get('address').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="city">City/Town</label>
                                        <input class="form-control resize-none" id="city" type="text" formControlName="city">
                                        <small *ngIf="submitted && addAddressForm.get('city').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="state">State</label>
                                        <select class="form-control resize-none" id="state"   formControlName="state_id">
                                            <option value="">Select State</option>
                                            <option [value]="state.id" *ngFor="let state of states">{{state?.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addAddressForm.get('state_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="pin-code">Pin Code</label>
                                        <input class="form-control" id="pin-code" type="text" formControlName="pin_code">
                                        <small *ngIf="submitted && addAddressForm.get('pin_code').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="gst_no">GSTIN</label>
                                        <input class="form-control" id="gst_no" type="text" formControlName="gst_no">
                                        <small *ngIf=" submitted && addAddressForm && addAddressForm.controls && addAddressForm.controls['gst_no'] && addAddressForm.controls['gst_no'].errors && addAddressForm.controls['gst_no'].errors.pattern"
                                               class="text-danger">Invalid GSTIN format.</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="reset" rippleEffect class="btn btn-danger" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>
